import { Grid, InputAdornment } from '@material-ui/core';
import { connect, Field } from 'formik';
import { agent } from 'helpers/agent';
import React, { useState, useEffect } from 'react';
import { API_MYEDUZZ } from 'settings';
import createShowIf from 'v2/components/Shared/createShowIf';
import { DatePickerFormField } from 'v2/components/Shared/FormFields/DatePickerFormField';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { SwitchFormField } from 'v2/components/Shared/FormFields/SwitchFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';

import type { IForm } from 'v2/components/Shared/Content';

import { EChargeType } from '../../classes/Product';

import type { Subscription as SubscriptionClass } from '../../classes/Payment';
import type { ICurrency } from '../../classes/Product';

interface IProps extends IForm<SubscriptionClass> {}

const Subscription = (props: Partial<IProps>) => {
  const { values } = props.formik;
  const { setFocus } = props;
  const [currencies, setCurrencies] = useState([]);

  const fetchData = async () => {
    const result = await agent.get(`${API_MYEDUZZ}/currencies`);
    setCurrencies(result.data.data);
  };

  const listCurrencies = currencies.map((currency: ICurrency) => {
    return { label: `${currency.code} - ${currency.name}`, value: currency.id };
  });

  const ShowIfSubscription = createShowIf<SubscriptionClass>();

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <ShowIfSubscription value={values} compare={{ eq: { charge_type: EChargeType.SUBSCRIPTION } }}>
      <Grid item xs={12}>
        <Field
          label='Moeda'
          id='currency.id'
          name='currency.id'
          component={SelectFormField}
          options={listCurrencies.filter((currency) => currency.value === 1)}
          selected={1}
          disabled
        />
      </Grid>
      <Grid item xs={12}>
        <Field label='Preço' name='price' id='price' mask='money' onFocus={setFocus} component={TextFormField} />
      </Grid>
      <Grid item xs={12}>
        <Field
          label='Tipo de frequência de cobrança'
          id='recurring_frequency_type'
          name='recurring_frequency_type'
          options={[
            { label: 'Mensal', value: 'M' },
            { label: 'Trimestral', value: 'TM' },
            { label: 'Semestral', value: 'SM' },
            { label: 'Anual', value: 'Y' },
          ]}
          component={SelectFormField}
        />
      </Grid>
      <Grid item xs={12}>
        recurring_frequency: {values.recurring_frequency}
        <Field label='Frequência' name='recurring_frequency' id='recurring_frequency' type='number' onFocus={setFocus} component={TextFormField} />
      </Grid>
      <Grid item xs={12}>
        <Field
          id='recurring_start_charging'
          name='recurring_start_charging'
          label='Começar a cobrar após'
          disablePast
          component={DatePickerFormField}
        />
      </Grid>
      <ShowIfSubscription
        value={values}
        compare={{
          eq: [
            { recurring_frequency_type: 'Y' },
            { recurring_frequency_type: 'BM' },
            { recurring_frequency_type: 'TM' },
            { recurring_frequency_type: 'QM' },
            { recurring_frequency_type: 'SM' },
          ],
        }}
      >
        <Grid item xs={12}>
          <Field
            id='allow_installment_checkout'
            name='allow_installment_checkout'
            label='Habilitar Parcelamento no Checkout'
            component={SwitchFormField}
          />
        </Grid>
      </ShowIfSubscription>
      <Grid item xs={12}>
        <Field id='undetermined_charges' name='undetermined_charges' label='Limitar quantidade de cobranças' component={SwitchFormField} />
      </Grid>
      <ShowIfSubscription value={values} compare={{ eq: { undetermined_charges: true } }}>
        <Grid item xs={12}>
          <Field label='Limite de cobranças' name='limit_charges' id='limit_charges' type='number' onFocus={setFocus} component={TextFormField} />
        </Grid>
      </ShowIfSubscription>
      <ShowIfSubscription value={values} compare={{ diff: { allow_installment_checkout: true, membership_fee: true } }}>
        <Grid item xs={12}>
          <Field id='has_trial' name='has_trial' label='Período trial' component={SwitchFormField} />
        </Grid>
        <ShowIfSubscription value={values} compare={{ eq: { has_trial: true } }}>
          <Grid item xs={12}>
            <Field
              label='Quantidade de dias (Trial)'
              name='trial_days'
              id='trial_days'
              type='number'
              onFocus={setFocus}
              InputProps={{
                startAdornment: <InputAdornment position='start'>Dias</InputAdornment>,
              }}
              component={TextFormField}
            />
          </Grid>
        </ShowIfSubscription>
      </ShowIfSubscription>
      <ShowIfSubscription value={values} compare={{ diff: { allow_installment_checkout: true, has_trial: true } }}>
        <Grid item xs={12}>
          <Field id='membership_fee' name='membership_fee' label='Taxa de contratação / Adesão?' component={SwitchFormField} />
        </Grid>
        <ShowIfSubscription value={values} compare={{ eq: { membership_fee: true } }}>
          <Grid item xs={12}>
            <Field
              label='Valor da adesão'
              name='membership_price'
              id='membership_price'
              onFocus={setFocus}
              InputProps={{
                startAdornment: <InputAdornment position='start'>R$</InputAdornment>,
              }}
              component={TextFormField}
              mask='money'
            />
          </Grid>
        </ShowIfSubscription>
      </ShowIfSubscription>
      <Grid item xs={12}>
        <Field
          label='Entregar conteúdo apenas na primeira cobrança paga'
          name='deliver_first_charge'
          id='deliver_first_charge'
          component={SwitchFormField}
        />
      </Grid>
      <Grid item xs={12}>
        <Field label='Remover acesso ao conteúdo no atraso da assinatura' name='remove_access' id='remove_access' component={SwitchFormField} />
      </Grid>
    </ShowIfSubscription>
  );
};

export default connect(Subscription);
